import { Controller } from '@hotwired/stimulus'

// Flowbite の data-dropdown-toggle を置き換える素のドロップダウン実装（issue #2203）。
// ボタンクリックで menu ターゲットの hidden を切り替え、外側クリックで閉じる。
// menu の位置指定は position: absolute な CSS（fronts.haml 側）で行う。
// これが無いと menu 表示時に flex の兄弟要素として扱われ、justify-between でボタン位置がずれる。
export default class extends Controller {
  static targets = ['button', 'menu']

  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener('click', this.boundCloseOnClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseOnClickOutside)
  }

  toggle() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('hidden')
      this.updateAriaExpanded()
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
      this.updateAriaExpanded()
    }
  }

  updateAriaExpanded() {
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', !this.menuTarget.classList.contains('hidden'))
    }
  }

  closeOnClickOutside(event) {
    if (this.hasMenuTarget && !this.menuTarget.classList.contains('hidden') && !this.element.contains(event.target)) {
      this.hide()
    }
  }
}
